export enum Role {
    Employee = 'Personalas_Nugis',
    Manager = 'Vadovai_Nugis',
    Administrator = 'Administrators_Nugis'
}
